import SvgIcon from '@material-ui/core/SvgIcon';

export default function EqualsIcon(props) {
    return (
        <SvgIcon {...props}>
            <path d="M2 5 l20 0 l0 5 l-20 0z"></path>
            <path d="M2 14 l20 0 l0 5 l-20 0z"></path>
        </SvgIcon>
    );
}
